import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export function usePlacementCohorts() {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_COHORTS, {
    defaultValue: {
      cohorts: [],
      flexReviewsInJobs: {
        enabled: false,
        windowStartDate: "2026-03-06",
        minFlexRatingsCountToShow: 0,
        maxCohortSize: 1000,
      },
      interviewsOnJobCards: {
        cutoffDate: "2026-03-06",
        enabled: false,
        maxCohortSize: 1000,
      },
    },
  });
}
